import { render, staticRenderFns } from "./TruckScheduleRequestForm.vue?vue&type=template&id=aa15fc24&scoped=true&"
import script from "./TruckScheduleRequestForm.vue?vue&type=script&lang=js&"
export * from "./TruckScheduleRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./TruckScheduleRequestForm.vue?vue&type=style&index=0&id=aa15fc24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa15fc24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemActionText } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VAutocomplete,VChip,VCol,VDatePicker,VDivider,VListItem,VListItemAction,VListItemActionText,VListItemContent,VListItemTitle,VRow,VSelect,VTextarea,VVirtualScroll})
